export class BankAccount {
    public iban: string;
    public ownerName: string;

    public toString(): string {
        let resp: string = '';

        resp += 'iban:' + this.iban;
        resp += ', ownerName:' + this.ownerName;

        return resp;
    }
}
